module.exports = __webpack_public_path__ + "static/media/Stash.450763d8.svg";